export const icedOutLyrics = [
  { text: "If you had to sacrifice", start: 0, end: 3.25 },
  { text: "All the things you've been working towards", start: 3.25, end: 5.6 },
  { text: "A vice, for some things you just can't afford", start: 5.6, end: 9.16 },
  { text: "That flight", start: 9.16, end: 10.29 },
  { text: "Baby gon head and just deboard", start: 10.29, end: 12.9 },
  { text: "You spend your check before you get it", start: 12.9, end: 15.4 },
  { text: "A lie", start: 15.4 , end: 18 },
  { text: "That you sell just so you'll fit in", start: 18, end: 20.5 },
  { text: "A like", start: 20.5, end: 21 },
  { text: "So you can brag about it to your friends", start: 21, end: 24  },
  { text: "Why do all of your achievements need an audience", start: 24, end: 27.8 },
  { text: "Can't take it with you when it's finished", start: 27.8, end: 30.3 },
  { text: "Go buy you a", start: 30.3, end: 31.7 },
  { text: "(Patek patek patek)", start: 31.7, end: 33 },
  { text: "Or a car with your black card", start: 33, end: 35 },
  { text: "(magic magic magic)", start: 35, end: 36.5 },
  { text: "They don't know that it's your cash card", start: 36.5, end: 38.8  },
  { text: "(tragic tragic tragic)", start: 38.8, end: 40 },
  { text: "You call it a flex but I see a fraud", start: 40, end: 43.5 },
  { text: "Mmm", start: 43.5, end: 46 },
  { text: "Money ego power", start: 46, end: 47.4 },
  { text: "It's a pyramid scheme", start: 47.4, end: 49.2 },
  { text: "All your likes are just to witness the American dream", start: 49.2, end: 52.8 },
  { text: "Wealth is of the heart and mind not what you see on a screen", start: 52.8, end: 56.7 },
  { text: "You see what people want you to see", start: 56.7, end: 59.5 },
  { text: "I bought a bag today put misery on layaway", start: 59.5, end: 64.4 },
  { text: "It's so much easier to buy some grace than process pain", start: 64.4, end: 68.39 },
  { text: "My money loves me", start: 68.39, end: 69.7 },
  { text: "My money trusts me", start: 69.7, end: 71 },
  { text: "Money gon keep me warm at night", start: 71, end: 72.5 },
  { text: "My money calls me", start: 72.5, end: 73.5 },
  { text: "Promising me", start: 73.5, end: 74.3 },
  { text: "Promising endless peace", start: 74.3, end: 75.5 },
  { text: "(Tick tock tick tick tick tick tick tock tick)", start: 75.5, end: 76 },
  { text: "Money, ego, power, the American dream", start: 76, end: 78.7 },
  { text: "Money, ego, power, it's a pyramid scheme", start: 78.7, end: 82.4 },
  { text: "Money, ego, power, the American dream", start: 82.4, end: 86.0 },
  { text: "It's a pyramid scheme", start: 86.0, end: 87.7 },
  { text: "It's a pyramid scheme", start: 87.7, end: 89.3 },
  { text: "It's a pyramid scheme", start: 89.3, end: 90.7 },
  { text: "Tick tock tick tick tick tick tick", start: 90.7, end: 92 },
  { text: "(The American dream)", start: 92, end: 93.6 },
  { text: "Tock tick tock Tick tock tick tick tick tick tick", start: 93.6, end: 95 },
  { text: "(It's a pyramid scheme)", start: 95, end: 97.3  },
  { text: "Tock tick tock Tick tock tick tick tick tick tick", start: 97.3, end: 99.5 },
  { text: "(The American dream)", start: 99.5, end: 101 },
  { text: "Tock tick tock Tick tock tick tick tick tick tick tock tick tock", start: 101, end: 105.6 },
  { text: "You sold your soul just for a bag my nigga", start: 105.6, end: 107.7  },
  { text: "I can't relate", start: 107.7, end: 108.8 },
  { text: "Niggas is bold", start: 108.8, end: 109.5 },
  { text: "Niggas is trash allow me to demonstrate", start: 109.5, end: 112.5 },
  { text: "They wanna sign you for 10 bands", start: 112.5, end: 114.5 },
  { text: "Throw a bag, hide their hand", start: 114.5, end: 116.37 },
  { text: "Then claim it don't get no better then this", start: 116.37, end: 119.3 },
  { text: "It would be the last green that you'd ever seen", start: 119.3, end: 124.08 },
  { text: "Ain't no need for talent", start: 124.08, end: 126.8 },
  { text: "Ain't no need for dreams", start: 126.8, end: 129.4 },
  { text: "I pity the fool who's only fueled by greed", start: 129.4, end: 133.8 },
  { text: "Greed", start: 133.8, end: 144.5 },
  { text: "Money ego power it's a pyramid scheme", start: 144.5, end: 147.5  },
  { text: "All your likes are just to witness the American dream", start: 147.5, end: 151 },
  { text: "Wealth is of the heart and mind not what you see on a screen", start: 151, end: 154.8 },
  { text: "You see what people want you to see", start: 154.8, end: 157.5 },
  { text: "Tick tock tick tick tick tick tick tock tick", start: 157.5, end: 161.5 },
  { text: "Tick tock tick tick tick tick tick tock tick", start: 161.5, end: 165.5 },
  { text: "Tick tock tick tick tick tick tick tock tick", start: 165.5, end: 169.5 },
  { text: "Tick tock tick tick tick tick tick tock ti", start: 169.5, end: 175 },
] as const satisfies ReadonlyArray<{
  readonly text: string;
  readonly start: number;
  readonly end: number;
}>;
